export let SavedSearchType;

(function (SavedSearchType) {
  SavedSearchType["RecentSearch"] = "recent_search";
  SavedSearchType["SubscribedSearch"] = "subscribed_search";
})(SavedSearchType || (SavedSearchType = {}));

export let SearchStartType;

(function (SearchStartType) {
  SearchStartType["SearchSuggestions"] = "search_suggestions";
  SearchStartType["SearchManual"] = "search_manual";
})(SearchStartType || (SearchStartType = {}));